<template>
  <div class="recyclertAddEdit">
    <el-form
      :model="userruleForm"
      :rules="rules"
      ref="userruleForm"
      label-width="100px"
      class="demo-userruleForm"
    >
      <el-form-item label="用户地址" prop="wlCommunityId">
        <el-select
          v-model="userruleForm.wlCommunityId"
          @change="addressChange"
          placeholder="请选择用户地址"
          style="width: 100%"
        >
          <el-option
            :label="item.allAddress"
            :value="item.id"
            v-for="(item, key) in addressList"
            :key="key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="姓名" prop="userName">
        <el-input :readonly="isQuery" v-model="userruleForm.userName"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input :readonly="isQuery" v-model="userruleForm.phone"></el-input>
      </el-form-item>
      <el-form-item label="街道" prop="streetId">
        <el-select
          :disabled="isQuery"
          v-model="userruleForm.streetId"
          @change="streetchange"
          placeholder="请选择街道"
        >
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="(item, key) in streetList"
            :key="key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="社区" prop="commuityId">
        <el-select
          :disabled="userruleForm.streetId.length == 0 || isQuery"
          v-model="userruleForm.commuityId"
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键词"
          :remote-method="remoteMethodcommunity"
          @change="commuityId"
        >
          <el-option
            v-for="item in communityList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="详细地址" prop="detailAddress">
        <el-input :readonly="isQuery" v-model="userruleForm.detailAddress"></el-input>
      </el-form-item>
      <el-form-item v-if="!isQuery">
        <el-button type="primary" @click="submitForm('userruleForm')">提交</el-button>
        <el-button @click="resetForm('userruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  frontUserlist,
  addressstreetlist,
  addresscommunitylist,
  statisticaladdressList,
} from "@/api/management"
export default {
  name: "recyclertAddEdit",
  props: ["isWhat", "userData", "isQuery"],
  data () {
    return {
      addressList: [],
      wlStreetId: [],
      name: "",
      value: [],
      loading: false,
      streetList: [],
      communityList: [],
      userruleForm: {
        userName: "",
        phone: "",
        wlCommunityId: '',
        streetId: "",
        commuityId: "",
        commuityName: "",
        detailAddress: "",
        userId: "",
        addressId: "",
      },
      rules: {
        userName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { min: 11, max: 11, message: "手机号不正确", trigger: "blur" },
        ],
        streetId: [
          {
            required: true,
            message: "请选择街道",
            trigger: "change",
          },
        ],
        commuityId: [
          {
            required: true,
            message: "请选择社区",
            trigger: "change",
          },
        ],
        adddetailAddressress: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
      },
    }
  },
  computed: {},
  methods: {
    commuityId (val) {
      this.communityList.forEach((item) => {
        if (item.id == val) {
          this.userruleForm.commuityName = item.name
        }
      })
    },
    getaddresscommunitylist (name, wlStreetId) {
      if (wlStreetId != 0) {
        addresscommunitylist({
          name: name,
          wlStreetId: wlStreetId,
        }).then((res) => {
          if (res.code == 200) {
            this.communityList = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    remoteMethodcommunity (query) {
      this.name = query
      this.getaddresscommunitylist(this.name, [this.wlStreetId])
    },
    streetchange (val) {
      this.userruleForm.commuityId = ""
      this.wlStreetId = val
      this.getaddresscommunitylist(this.name, [this.wlStreetId])
    },
    getaddressstreetlist () {
      addressstreetlist({ name: this.userData.street }).then((res) => {
        console.log(res.data, 'addressstreetlist')
        if (res.code == 200) {
          this.streetList = res.data
          if (this.userData.userId) {
            this.getstatisticaladdressList()
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // getfrontUserlist () {
    //   frontUserlist({ name: "" }).then((res) => {
    //     console.log(res.data)
    //     if (res.code == 200) {
    //       this.options = res.data
    //     } else {
    //       this.$message.error(res.msg)
    //     }
    //   })
    // },
    getstatisticaladdressList () {
      statisticaladdressList({ userId: this.userData.userId }).then((res) => {
        console.log(res.data, 'statisticaladdressList')
        if (res.code == 200) {
          console.log(this.userData)
          this.userruleForm.userId = this.userData.userId
          this.userruleForm.userName = this.userData.nickname
          // this.userruleForm.phone = res.data[0].mobile
          // this.userruleForm.detailAddress = res.data[0].addressDetails

          this.addressList = res.data
          this.addressList.forEach((item) => {
            item.allAddress = item.addressName + "-" + item.addressDetails
          })
          this.streetList.forEach((item) => {
            if (item.name == this.userData.street) {
              // this.userruleForm.streetId = item.id
              this.getaddresscommunitylist("", [this.userruleForm.streetId])
            }
          })
          // this.userruleForm.commuityId = this.userData.communityId
          // console.log(this.userData.communityId)
          // this.userruleForm.addressId = this.userData.addressId
          setTimeout(() => {
            this.userruleForm.commuityName = this.userData.community
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    addressChange (val) {
      console.log(this.addressList)
      this.addressList.forEach((item) => {
        if (val == item.id) {
          console.log(val)
          console.log(item)
          this.userruleForm.streetId = item.wlStreetId
          this.userruleForm.commuityId = item.wlCommunityId
          this.userruleForm.detailAddress = item.addressDetails
          this.userruleForm.allAddress = item.addressDetails
          this.userruleForm.phone = item.mobile
          this.userruleForm.addressId = item.id
          console.log(this.communityList)
          this.getaddresscommunitylist(item.addressName, [item.wlStreetId])
        }
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("saveSubmit", this.userruleForm)
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
  },
  created () {
    // this.getfrontUserlist()
    this.getaddressstreetlist()
    console.log(this.userData, 'userData')
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #666;
}
::v-deep .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #000;
  cursor: not-allowed;
}
.recyclertAddEdit {
  padding: 0px 24px 24px 24px;
  ::v-deep .el-select {
    width: 100%;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
